// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"oX","sortWrapper":"pX","shortCount":"qX","fullCount":"rX","countWrapper":"sX"};